import { motion } from "framer-motion";
import { MapPin } from "@phosphor-icons/react";

const CITIES = [
  {
    name: "Pune",
    image: "/cities/pune.png",
    localities: ["Baner", "Pimpri-Chinchwad", "Kothrud", "Viman Nagar", "Wakad", "Hinjewadi", "Aundh", "Hadapsar", "Kharadi", "Magarpatta"],
    tag: "Head Office",
  },
  {
    name: "Delhi",
    image: "/cities/delhi.png",
    localities: ["Connaught Place", "South Delhi", "Dwarka", "Rohini", "Vasant Kunj", "Saket", "Karol Bagh", "Janakpuri"],
  },
  {
    name: "Hyderabad",
    image: "/cities/hyderabad.png",
    localities: ["Gachibowli", "Banjara Hills", "Jubilee Hills", "Madhapur", "Kondapur", "Hitech City", "Kukatpally"],
  },
  {
    name: "Goa",
    image: "/cities/goa.png",
    localities: ["Panaji", "Margao", "Vasco", "Calangute", "Candolim", "Baga", "Anjuna", "Porvorim"],
  },
  {
    name: "Nagpur",
    image: "/cities/nagpur.png",
    localities: ["Dharampeth", "Civil Lines", "Sitabuldi", "Wardha Road", "Manish Nagar", "Ramdaspeth", "Pratap Nagar"],
  },
  {
    name: "Secunderabad",
    image: "/cities/secunderabad.png",
    localities: ["Trimulgherry", "Marredpally", "Alwal", "Sainikpuri", "Bowenpally", "Karkhana", "AS Rao Nagar"],
  },
  {
    name: "Chandigarh",
    image: "/cities/chandigarh.png",
    localities: ["Sector 17", "Sector 22", "Sector 34", "Sector 43", "Manimajra", "Panchkula", "Mohali"],
  },
  {
    name: "Bangalore",
    image: "/cities/bangalore.png",
    localities: ["Koramangala", "Indiranagar", "Whitefield", "HSR Layout", "Electronic City", "Marathahalli", "JP Nagar", "Jayanagar"],
  },
];

export default function Areas({ onBook }) {
  return (
    <section id="areas" className="py-24 md:py-32 bg-[var(--paper)]" data-testid="areas">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="max-w-2xl mb-14">
          <p className="label-caps text-[var(--gold)] mb-4">Pan India Service Provider</p>
          <h2 className="font-display text-4xl md:text-6xl text-[var(--navy)] tracking-tighter leading-[1.02]">
            Trusted care, in every corner of India.
          </h2>
          <p className="mt-5 text-slate-600 leading-relaxed">
            Verified maids, cooks and caretakers placed at your doorstep — right
            in your neighbourhood, across 8 cities and growing.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {CITIES.map((c, i) => (
            <motion.button
              key={c.name}
              onClick={() => onBook && onBook()}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.55, delay: (i % 3) * 0.08, ease: [0.22, 1, 0.36, 1] }}
              className="group text-left relative rounded-3xl overflow-hidden bg-white border border-slate-200 hover:shadow-2xl hover:-translate-y-1 transition-[transform,box-shadow] duration-300"
              data-testid={`city-card-${c.name.toLowerCase()}`}
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={c.image}
                  alt={`${c.name} landmark`}
                  className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[var(--navy)]/85 via-[var(--navy)]/30 to-transparent" />
                <div className="absolute top-3 left-3 flex items-center gap-1.5 rounded-full bg-white/90 backdrop-blur px-3 py-1 text-[11px] font-bold text-[var(--navy)] uppercase tracking-wider">
                  <MapPin size={12} weight="fill" className="text-[var(--gold)]" />
                  {c.tag || "Now Serving"}
                </div>
                <div className="absolute bottom-3 left-4">
                  <h3 className="font-display text-3xl text-white drop-shadow-md tracking-tight">
                    {c.name}
                  </h3>
                </div>
              </div>

              <div className="p-5">
                <p className="text-[11px] font-bold uppercase tracking-wider text-[var(--gold)]">
                  Areas we serve
                </p>
                <p className="mt-2 text-sm text-slate-600 leading-relaxed">
                  {c.localities.slice(0, 6).join(", ")}
                  {c.localities.length > 6 && ", & more"}
                </p>
              </div>
            </motion.button>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-slate-500 text-sm">
            Don&apos;t see your city? Call us — we&apos;re expanding fast.
          </p>
          <button
            onClick={() => onBook && onBook()}
            className="mt-4 rounded-full bg-[var(--navy)] text-white font-bold px-8 py-3.5 hover:bg-[var(--navy-deep)] transition-colors"
            data-testid="areas-book-btn"
          >
            Book a service near you
          </button>
        </div>
      </div>
    </section>
  );
}
